export type RoomFeature = {
  readonly id: number;
  readonly name: string;
  readonly category: string;
  readonly basic: boolean;
  readonly priority: number;
};

export function createRoomFeature(values: unknown): RoomFeature {
  const { id, name, category, basic, priority } = values as RoomFeature;

  return {
    id,
    name,
    category,
    basic,
    priority,
  };
}
